export default "__VITE_ASSET__fQwoinoK__"